<template>
	<Drag></Drag>
	<!-- <Index></Index> -->
	<!-- <Pixi></Pixi> -->
</template>

<script>
	import Index from './components/index.vue'
	import Drag from './components/drag.vue'
	import Pixi from './components/pixijs.vue'
	
	export default {
		name: 'app',
		components: {
			Index,
			Drag,
			Pixi
		}
	}
</script>

<style>

</style>
